export const EDERCARE_REDUCER_KEY = 'hire-services';
export const SERVICE_STORAGE_PREFIX = 'service-';